var n = new Set();

function a(a) {
  n.has(a) || (n.add(a), console.warn(a));
}

export { a as warn };